(function () {
  function initForm(form) {
    if (form.dataset.llContactReady === 'true') return;
    form.dataset.llContactReady = 'true';

    var status = form.querySelector('[data-ll-contact-status]');
    var submit = form.querySelector('[data-ll-contact-submit]');
    var source = form.querySelector('[name="bronpagina"]');
    var message = form.querySelector('[name="bericht"]');
    var counter = form.querySelector('[data-ll-contact-count]');
    var files = form.querySelector('[name="bijlagen"]');
    var sending = false;
    if (source) source.value = window.location.href.split('#')[0];

    function clearError(field) {
      field.removeAttribute('aria-invalid');
      var error = document.getElementById(field.id + '-error');
      if (error) error.remove();
      var describedBy = (field.getAttribute('aria-describedby') || '').split(' ').filter(function (id) {
        return id && id !== field.id + '-error';
      });
      if (describedBy.length) field.setAttribute('aria-describedby', describedBy.join(' '));
      else field.removeAttribute('aria-describedby');
    }

    function showError(field) {
      clearError(field);
      field.setAttribute('aria-invalid', 'true');
      var error = document.createElement('small');
      error.id = field.id + '-error';
      error.className = 'll-contact-form__error';
      error.textContent = field.validationMessage;
      field.parentNode.appendChild(error);
      field.setAttribute('aria-describedby', ((field.getAttribute('aria-describedby') || '') + ' ' + error.id).trim());
    }

    function validateField(field) {
      field.setCustomValidity('');
      if (field.required && !field.value.trim()) field.setCustomValidity('Vul dit veld in.');
      else if (field.type === 'email' && field.validity.typeMismatch) field.setCustomValidity('Vul een geldig e-mailadres in, bijvoorbeeld naam@bedrijf.nl.');
      else if (field.maxLength > 0 && field.value.length > field.maxLength) field.setCustomValidity('Gebruik maximaal ' + field.maxLength + ' tekens.');
      if (field !== files) return;
      var selected = Array.prototype.slice.call(files.files || []);
      var allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
      if (selected.length > 5) files.setCustomValidity('Kies maximaal 5 bestanden.');
      else if (selected.some(function (file) { return !allowedTypes.includes(file.type); })) files.setCustomValidity('Kies JPG-, PNG-, WebP- of PDF-bestanden.');
      else if (selected.some(function (file) { return file.size === 0 || file.size > 10 * 1024 * 1024; })) files.setCustomValidity('Elk bestand moet inhoud hebben en mag maximaal 10 MB groot zijn.');
      else if (selected.reduce(function (total, file) { return total + file.size; }, 0) > 25 * 1024 * 1024) files.setCustomValidity('De bestanden mogen samen maximaal 25 MB groot zijn.');
    }

    function updateCounter() {
      if (counter && message) counter.textContent = message.value.length + ' / 1.000 tekens';
    }

    Array.prototype.forEach.call(form.querySelectorAll('input:not([type="hidden"]), select, textarea'), function (field) {
      field.addEventListener('input', function () {
        validateField(field);
        if (field.validity.valid) clearError(field);
        if (field === message) updateCounter();
      });
    });
    if (files) files.addEventListener('change', function () {
      validateField(files);
      if (!files.validity.valid) showError(files);
      else clearError(files);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (sending) return;

      Array.prototype.forEach.call(form.querySelectorAll('input:not([type="hidden"]), select, textarea'), function (field) {
        clearError(field);
        validateField(field);
        if (!field.validity.valid) showError(field);
      });

      if (!form.checkValidity()) {
        var invalid = form.querySelector(':invalid');
        if (invalid) {
          invalid.focus();
        }
        status.textContent = 'Controleer de gemarkeerde velden.';
        status.dataset.state = 'error';
        return;
      }

      sending = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      status.textContent = 'Je bericht wordt verstuurd...';
      status.dataset.state = '';

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok || !data.ok) {
              throw new Error(data.message || 'Versturen is niet gelukt. Probeer het opnieuw.');
            }
            return data;
          });
        })
        .then(function (data) {
          form.reset();
          updateCounter();
          if (source) source.value = window.location.href.split('#')[0];
          status.textContent = data.message || 'Bedankt, je bericht is ontvangen.';
          status.dataset.state = 'success';
          status.focus();
        })
        .catch(function (error) {
          status.textContent = error instanceof TypeError
            ? 'We konden de ontvangst niet bevestigen. Je invoer staat er nog. Controleer je verbinding; neem bij twijfel contact op via info@laserlokaal.nl.'
            : error.message || 'Versturen is niet gelukt. Je invoer staat er nog. Probeer het opnieuw.';
          status.dataset.state = 'error';
          status.focus();
        })
        .then(function () {
          sending = false;
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        });
    });
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-ll-contact-form]'), initForm);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
